<h2 class="first_title">Agenda legale</h2>
<div export-help [pageNumber]="'153'"></div>
<div class="content-page-wrapper">
  <ng-container *ngIf="viewManager.descriptors$ | async as descriptors">
    <div *ngIf="uploadedFiles != null && uploadedFiles.length > 0 && getDocumentManagementDescriptor(descriptors)?.readable">
      <h3 class="titletogglepanel icon_user"><a data-toggle="collapse" href="#panelcontentfiles" aria-expanded="true"
        aria-controls="panelcontent2">Documenti da inviare</a></h3>
      <div class="collapse togglepanel in" id="panelcontentfiles">
        <div *ngFor="let file of uploadedFiles" class="uploaded-doc-item">
          <app-upload-progress
            (onFileItemClick)="openUploadPanelDialog(file)"
            (onDeleteItem)="onDeleteFile($event)"
            (onEditItem)="onEditFile($event)"
            [file]="file"
            [descriptor]="getDocumentManagementDescriptor(descriptors)">
          </app-upload-progress>
        </div>
      </div>
    </div>
  </ng-container>
  
  <h3 class="titletogglepanel icon_user"><a data-toggle="collapse" href="#panelcontentCalendar" aria-expanded="true"
      aria-controls="panelcontentCalendar" (click)="loadCalendar();false">Calendario</a></h3>
  <div class="collapse togglepanel in" id="panelcontentCalendar">
    <ng-template ngbModalContainer></ng-template>
    <div class="ngcalendar ng-scope" id="calendarElement">
      <div class="btn-group switchview">
        <button class="btn btn-primary" (click)="changedView('month')" [class.active]="view === 'month'">Mese</button>
        <button class="btn btn-primary" (click)="changedView('week')" [class.active]="view === 'week'">Settimana</button>
        <button class="btn btn-primary" (click)="changedView('day')" [class.active]="view === 'day'">Giorno</button>
      </div>
  
      <div class="btn-group navview">
        <button class="btn btn-primary" mwlCalendarPreviousView [view]="view" (viewDateChange)="viewDateChange($event)"
          [(viewDate)]="viewDate">
          <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>Precedente</button>
        <button class="btn btn-secondary today" mwlCalendarToday (viewDateChange)="viewDateChange($event)"
          [(viewDate)]="viewDate">Oggi</button>
        <button class="btn btn-primary" mwlCalendarNextView [view]="view" (viewDateChange)="viewDateChange($event)"
          [(viewDate)]="viewDate">
          Successivo<span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span></button>
      </div>
  
      <h2 class="ng-binding visibility-date">{{ formattaData(viewDate | calendarDate:(view + 'ViewTitle'):'it-IT') }}</h2>
      <div class="row" style="margin: 0; padding: 0;">
        <div comboModInput class="col-sm-4 col-xs-6" style="width: 20% !important; margin: -20px 0px 0px -15px;" [labelInput]="'Filtra eventi'"
          [objectReference]="eventoSel" (onReturn)="cambioEvento($event)" [optionsCombo]="eventi">
        </div>
        <div class="col-sm-8 col-xs-6"></div>
      </div>
      <br>
      <!--<div spinner-load [waiting]="calendarLoaded"></div>-->
      <div [ngSwitch]="view">
        <mwl-calendar-month-view *ngSwitchCase="'month'" [viewDate]="viewDate" [events]="events" [locale]="'it-it'"
          [refresh]="refresh" [activeDayIsOpen]="activeDayIsOpen" (dayClicked)="dayClicked($event.day)"
          (eventClicked)="handleEvent('Clicked', $event.event)" (eventTimesChanged)="eventTimesChanged($event)">
        </mwl-calendar-month-view>
  
        <mwl-calendar-week-view *ngSwitchCase="'week'" [viewDate]="viewDate" [events]="events" [locale]="'it-it'"
          [refresh]="refresh" (eventClicked)="handleEvent('Clicked', $event.event)"
          (eventTimesChanged)="eventTimesChanged($event)">
        </mwl-calendar-week-view>
  
        <mwl-calendar-day-view *ngSwitchCase="'day'" [locale]="'it-it'" [viewDate]="viewDate" [events]="events"
          [refresh]="refresh" (eventClicked)="handleEvent('Clicked', $event.event)"
          (eventTimesChanged)="eventTimesChanged($event)" [tooltipPlacement]="'top'">
        </mwl-calendar-day-view>
  
      </div>
  
    </div>
  </div>
  
  <h3 class="titletogglepanel icon_user"><a data-toggle="collapse" href="#panelcontent2" aria-expanded="true"
      aria-controls="panelcontent2">Prossimi adempimenti</a></h3>
  <div class="collapse togglepanel in" id="panelcontent2">
    <ul *ngIf="prossimiAdempimentiList.length > 0" prossimi-adempimenti-list class="att_completare"
      [slice]="numToViewProssimiAdempimenti" [adempimenti]="prossimiAdempimentiList" [viewOption]="true"
      (onReturn)="refreshCalendar('evasione')" (rinvia)="rinvioAdempimento($event)"></ul>
  
    <div *ngIf="prossimiAdempimentiList.length == 0">
      <p class="allinea_centro">Non ci sono adempimenti nei prossimi 7 giorni</p>
    </div>
    <p class="read_more"><a [routerLink]="['/', viewAllProssimiAdempimenti ]">Vedi tutti</a></p>
  </div>
  
  <h3 class="titletogglepanel icon_user"><a data-toggle="collapse" href="#panelcontent3" aria-expanded="true"
      aria-controls="panelcontent3">Adempimenti inevasi</a></h3>
  <div class="togglepanel collapse in" id="panelcontent3">
    <ul *ngIf="adempimentiInevasiList.length > 0" adempimenti-inevasi-list class="att_completare"
      [slice]="numToViewAdempimentiInevasi" [adempimenti]="adempimentiInevasiList" [viewOption]="true"
      (onReturn)="refreshCalendar('evasione')" (rinvia)="rinvioAdempimento($event)"></ul>
    <div *ngIf="adempimentiInevasiList.length == 0">
      <p class="allinea_centro">Non ci sono adempimenti inevasi</p>
    </div>
    <p class="read_more"><a [routerLink]="['/', viewAllAdempimentiInevasi ]">Vedi tutti</a></p>
  </div>
  
  <h3 class="titletogglepanel icon_user"><a data-toggle="collapse" href="#panelcontent4" aria-expanded="true"
      aria-controls="panelcontent4">Attivit&agrave; da completare</a></h3>
  <div class="togglepanel collapse in" id="panelcontent4">
    <ul attivita-completare-list *ngIf="attivitaCompletareList.length > 0" class="att_completare"
      [attivitaList]="attivitaCompletareList" [slice]="numToViewAttivitaCompletare"></ul>
    <div *ngIf="attivitaCompletareList.length == 0">
      <p class="allinea_centro">Non ci sono attivit&agrave; da completare</p>
    </div>
    <p class="read_more"><a [routerLink]="['/', viewAllAttivitaCompletare ]">Vedi tutti</a></p>
  </div>
  <h3 class="titletogglepanel icon_user"><a data-toggle="collapse" href="#panelcontent6" aria-expanded="true"
      aria-controls="panelcontent6">Notifiche</a></h3>
  <div class="togglepanel collapse in" id="panelcontent6">
    <ul notifiche-list *ngIf="notifiche.length > 0" class="notifiche" [notifiche]="notifiche" [slice]="numToViewNotifiche"
      [hasOptions]="true"></ul>
    <div *ngIf="notifiche.length == 0">
      <p class="allinea_centro">Non ci sono notifiche</p>
    </div>
    <p class="read_more"><a [routerLink]="['/', viewAllNotifiche ]">Vedi tutti</a></p>
  </div>
  <div>
    <div class="sync-bar allinea_centro col-sm-12 pm-0">
      <button class="btn btn-default-reverse btn-block btn-sm" (click)="openCal()">
        <strong>Sincronizza il calendario con il tuo client di posta</strong>
      </button>
    </div>
  </div>
</div>


<div modale_rinvio_scadenza [attr.id]="'modalrinvioscad'" (onReturn)="refreshCalendar('rinvio')" #modaleRinvioScadenza>
</div>

<div #modalSyncCalendar
     modal-sync-calendar
     [calendarLink]="getUrlForICalendar()"
     [attr.id]="'modalSyncCalendar'"
     class="modal fade"
></div>
